export default {
  InterestRate: 'Interest Rate Risk',
  Title       : 'Net Interest Income',
  HeaderTitle : 'Net Interest Income',
  Tab         : {
    SynthesisRisk: {
      Title: 'Synthesis Risk',
      Slug : 'synthesis-risk',
      Tab  : {
        RiskMethod1ExtremeEvent: {
          Title  : 'Risk Method 1: Extreme Event',
          Slug   : 'risk-method-1-extreme-event',
          Tooltip: 'MISSING TOOLTIP'
        },
        RiskMethod2ForwardSimulations: {
          Title: 'Risk Method 2: Forward Simulations',
          Slug : 'risk-method-2-forward-simulations'
        },
        RiskMethod3HistoricalSpectrum: {
          Title         : 'Risk Method 3: Historical Spectrum',
          SecondaryTitle: 'Historical Spectrum',
          Slug          : 'risk-method-3-historical-spectrum'
        }
      }
    },
    InternalThresholds: {
      Title: 'Internal Thresholds',
      Slug : 'internal-thresholds'
    }
  },
  Section: {
    SynthesisRisk: {
      Title  : 'Synthesis Risk',
      Tooltip: 'MISSING TOOLTIP'
    },
    InternalThresholds: {
      NiiLimits: {
        Title  : 'NII Limits',
        Tooltip: 'MISSING TOOLTIP'
      }
    },
    PastAnalyses: {
      NIIRisk   : 'NII Risk',
      NIITooltip: 'MISSING TOOLTIP'
    }
  },
  PeriodSwitch: {
    Risk3m: '3-months Risk',
    Risk1y: '12-months Risk'
  },
  ExtremePeriod: {
    BestValues : ['Best12Month', 'Best6Month', 'Best3Month'],
    WorstValues: ['Worst12Month', 'Worst6Month', 'Worst3Month'],
    Buttons    : {
      Left: [
        {
          Title: 'Best 12 Months',
          Value: 'Best12Month',
          Color: 'synthesis-ui-green-01'
        },
        {
          Title: 'Best 6 Months',
          Value: 'Best6Month',
          Color: 'synthesis-ui-green-01'
        },
        {
          Title: 'Best 3 Months',
          Value: 'Best3Month',
          Color: 'synthesis-ui-green-01'
        }
      ],
      Right: [
        {
          Title: 'Worst 12 Months',
          Value: 'Worst12Month',
          Color: 'synthesis-ui-red-02'
        },
        {
          Title: 'Worst 6 Months',
          Value: 'Worst6Month',
          Color: 'synthesis-ui-red-02'
        },
        {
          Title: 'Worst 3 Months',
          Value: 'Worst3Month',
          Color: 'synthesis-ui-red-02'
        }
      ]
    }
  }
}
